import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Observable, Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

export class ItemCategory{
    text:string;
    value:string;
    children:ItemCategory[];
}

@Component({
    selector: 'app-viavarejo-category',
    templateUrl: './viavarejo-category.component.html',
    styleUrls: ['./viavarejo-category.component.scss'],
    providers: [
        { provide: TreeviewI18n, useClass: SimpleDataTreeviewI18n }
    ],
    standalone: false
})
export class ViaVarejoCategoryComponent implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  sub1:Subscription;
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
  }
  clientid: any;
  acesstoken: any;

  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,public ThemeService:ThemeService, public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  onSelectedChange(evento){
  }

  onFilterChange(evento){

  }

  onClickLine(evento:TreeviewItem){
    
    if ( evento.text=='A Carregar'){
      this.findChild(evento.value,evento);
    }else{
      if ( !evento.children ){
        this.dialogRef.close(evento.value);
      }
    }
    
  }

  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {

    
    this.codecompany = (this.data as UntypedFormGroup).get("CODECOMPANY").value;
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }

    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.ACESSTOKEN,A.CLIENTID
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}
            AND A.CODEMKTP=32
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }
     
    this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){

          this.clientid  = con['SQL'][0]['CLIENTID'];
          this.acesstoken  = con['SQL'][0]['ACESSTOKEN'];
          
          this.buttonList.push({
            color:"warn",
            description:"Sair",
            action: ()=>{
                this.okFunction();
            }
          })

          this.findCategories();
        }
      });
    
  }

  findCategories(){
    this.spinner.show();
    let ob = {
      "expressao": "getRequestData(GetCategory,Product4,?_offset=0&_limit=1000,GET,null,{@HEADER},{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 32,
      "codecontract": 0,
      "values":[] 
    }

    let header = {
      key:'@HEADER',
      value:`client_id:${this.clientid};access_token:${this.acesstoken}`
    }
    
    ob['values'].push(header);

    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
        this.transformData(data);
    },error=>{
        this.spinner.hide();
        throw error;
    },()=>{
        this.spinner.hide();
    })
  
  }


  findChild(id,item){
    this.spinner.show();

    return new Promise((resolve,reject)=>{
      let ob = {
        "expressao": "getRequestData(GetCategory,Product4,?_offset=0&_limit=1000"+"&id="+id+",GET,null,{@HEADER},{@CODEMKTP})",
        "novo": true,
        "codecompany": this.codecompany,
        "codemktp": 32,
        "codecontract": 0,
        "values":[] 
      }
  
      let header = {
        key:'@HEADER',
        value:`client_id:${this.clientid};access_token:${this.acesstoken}`
      }
      
      ob['values'].push(header);
  
      this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
          this.transformData2(data,item);
          resolve(true);
      },error=>{
          this.spinner.hide();
          throw error;
      },()=>{
          this.spinner.hide();
      })
    
    });
    
  }

  transformData(data):void{
    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children: []})];

    if ( data != null && ObjectUtil.isNotEmpty(data['resultado'])){
        
      let resultado = JSON.parse(data['resultado']);
      let array:[] = resultado;
    
      for ( var item of array){//.filter(i=>i['hasChildren'] == false )){
        
        let category_id = item['levelId'];
        let display_category_name = item['name'];
        let has_children = item['hasChildren'];
        let dataItem:TreeviewItem = new TreeviewItem({text:display_category_name, value:category_id,collapsed:true, checked:false });
        
        if ( this.lista[0].children == null ){
          this.lista[0].children = [dataItem];
        }else{
          this.lista[0].children.push(dataItem);      
        }
        
        
        if ( has_children){
          this.findItem(item['children'],category_id,dataItem);
        }
        
      }
    }
    
  }

  findParent(id, currentNode:TreeviewItem[]):TreeviewItem{
      
    var i,
        currentChild:TreeviewItem,
        result:TreeviewItem;
        for (i = 0; i < currentNode.length; i++ ){
            currentChild = currentNode[i];
            if ( currentChild.value == id ){
              return currentChild;
            }else{
                if ( currentChild.children ){
                    result = this.findParent(id, currentChild.children);

                    if (result != null) {
                      return result;
                    }
                }
            }
        }

        return null;
  }

  transformData2(data,itemData:TreeviewItem):void{
    
    if ( data != null && ObjectUtil.isNotEmpty(data['resultado'])){
      
      let resultado = JSON.parse(data['resultado']);
      let array:Object[] = resultado;
      let parent:number = array[0]['levelId']
      let parentData:TreeviewItem = this.findParent(parent,this.lista)
      
      if( parentData == null){
        return;
      }else{
        let index = parentData.children.findIndex(x=>x.value ==parent );
        parentData.children.splice(index,1);
      }

      for ( var item of array[0]['children']){//.filter(i=>i['hasChildren'] == false )){
        
        let category_id = item['levelId'];
        let display_category_name = item['name'];
        let has_children = item['hasChildren'];
        
        let dataItem:TreeviewItem = new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id,collapsed:true, checked:false });
        
        if ( parentData.children == null ){
          parentData.children = [dataItem];
        }else{
          parentData.children.push(dataItem);      
        }
        
        if ( has_children){
          this.findItem(item['children'],category_id,parentData);
        }
      }
    }
    
  }

  findItem(array:Object[],  category_id:string, lista:TreeviewItem):void{

      let newArray:Object[] = array.filter(data=> data['levelIdFather'] == category_id );
  
      for ( var item of newArray ){
          let has_children = item['hasChildren'];
          let category_id = item['levelId'];
          let display_category_name = item['name'];
          let children  = item['children'];

          if ( has_children && !children ){
            
            if ( lista.children == null ){
              lista.children = [ new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false, children:[new TreeviewItem({text:'A Carregar', value:category_id, collapsed:true, checked: false,  children:[] })] })];
            }else{
              lista.children.push( new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false,  children:[new TreeviewItem({text:'A Carregar', value:category_id, collapsed:true, checked: false,  children:[] })] }))
            }
          }else{
            if ( lista.children == null ){
              lista.children = [ new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false, children:[] })];
            }else{
              lista.children.push( new TreeviewItem({text:category_id + ' - '+ display_category_name, value:category_id, collapsed:true, checked: false,  children:[] }))
            }
          }

          
          
          
          if ( has_children && children ){
            this.findItem(array,category_id,lista);
          }

      }  
  }
  
  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
    if ( this.sub1!= null ){ this.sub1.unsubscribe()};

    
  }

}
